var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-slider',_vm._g(_vm._b({staticClass:"slider",attrs:{"thumb-label":"always","append-icon":"add","prepend-icon":"remove","tick-size":1},scopedSlots:_vm._u([{key:"thumb-label",fn:function({ value }){return [_vm._v(" "+_vm._s(_vm.label(value))+" ")]}}])},'v-slider',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }